var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("ESTADO")]),_c('div',[_c('p',[_vm._v(" estado do pedido - "+_vm._s(_vm.state.estado)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }